import { BASE_URL } from '../constants'
const token = JSON.parse(localStorage.getItem('token'))

export const searchTalents = ({ page = 0, search = '' }) => {
  const URL = `${BASE_URL}user/searchVerificationsTalents?searchText=${search}&page=${page}`

  try {
    const response = fetch(URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
      .then((response) => response.json())
      .then((res) => res)

    return response
  } catch (error) {
    console.log(error)
  }
}
